<div class="popup-container">
  <div class="popup-content-right">
    <i class="btn-close" (click)="onNoClick()"></i>
  </div>
  <div class="popup-content">
    <mat-icon class="material-icons-outlined" style="color: #de6421">
      {{ data.materialIcon }}
    </mat-icon>

    <div class="popup-title">
      {{ data.header }}
    </div>

    <div class="popup-subtitle">
      {{ data.subTitle }}
    </div>
    <div class="popup-actions">
      <button class="btn btn-warning" (click)="onNoClick()">Try Again</button>
    </div>
  </div>
</div>
